export const AVAILABILITY_TYPE = {
    AVAILABILITY_12_HOUR: 'AVAILABILITY_12_HOUR',
    AVAILABILITY_24_HOUR: 'AVAILABILITY_24_HOUR',
}
export const AVAILABILITY_FORMAT = {
    AVAILABILITY_12_HOUR : {
        TYPE: AVAILABILITY_TYPE.AVAILABILITY_12_HOUR,
        CELLS: 31,
        START_HOUR: 8,
        ROW_INDEX: 16,
        FORMAT: "hh:mma",
    },
    AVAILABILITY_24_HOUR : {
        TYPE: AVAILABILITY_TYPE.AVAILABILITY_24_HOUR,
        CELLS: 48,
        START_HOUR: 0,
        ROW_INDEX: 0,
        FORMAT: "HH:mma",
    },
}